// extracted by mini-css-extract-plugin
export default {"loaderContainer":"style_loaderContainer__IwvaY","loaderIcon":"style_loaderIcon__K4Yw0"};